export default __webpack_public_path__ + "static/lesli_gaynor_avatar-565481e994b9c992d4a6d9f915f99d82.png";